/**
 * Derives a simple image orientation from width/height when Orientation is absent.
 * L = landscape, P = portrait, S = square.
 */
export function deriveImageOrientation(
  width?: number,
  height?: number
): string | undefined {
  if (width == null || height == null || width <= 0 || height <= 0) {
    return undefined;
  }
  if (width > height) return "L";
  if (height > width) return "P";
  return "S";
}
